angular.module("ainapp")
    .controller("productQueryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Product Query";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    ProductIds: [],
                    Keyword: "",
                }
                $scope.load = false;

            }
            $scope.Init();

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.ProductIds = $scope.filter.ProductIds;
                        o.data.Keyword = $scope.filter.Keyword;

                        MainService.ProductQueryReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })


                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            Description: {
                                type: "string",
                                editable: false,
                            },
                            Brand: {
                                type: "string",
                                editable: false,
                            },
                            Manufacturer: {
                                type: "string",
                                editable: false,
                            },
                            BalanceQty: {
                                type: "number",
                                editable: false,
                            },
                            LastPurchasePrice: {
                                type: "number",
                                editable: false,
                            },
                            LastMovingCost: {
                                type: "number",
                                editable: false,
                            },
                            AverageCost: {
                                type: "number",
                                editable: false,
                            },
                            LastSellingPrice: {
                                type: "number",
                                editable: false,
                            },
                            AvgSellingPrice: {
                                type: "number",
                                editable: false,
                            },
                            WarehouseLoacation: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "ProductCode",
                        title: "Code",
                        },
                    
                    {
                        field: "Name",
                        title: "Product",
                        },
                    
                    {
                        field: "Description",
                        title: "Description",
                     },
                     {
                        field: "Brand",
                        title: "Brand",
                     },
                    {
                        field: "Manufacturer",
                        title: "Manufacturer",
                     },
                     {
                        field: "BalanceQty",
                        title: "Balance Qty",
                     },
                  
                     {
                        field: "LastPurchasePrice",
                        title: "Last Purchase Price",
                     },
                     {
                        field: "LastMovingCost",
                        title: "Last Moving Cost",
                     },
                  
                     {
                        field: "AverageCost",
                        title: "Average Cost",
                     },
                  
                  
                     {
                        field: "LastSellingPrice",
                        title: "Last Selling Price",
                     },
                  
                     {
                        field: "AvgSellingPrice",
                        title: "Avg Selling Price",
                     },
                  
                     {
                        field: "WarehouseLoacation",
                        title: "Warehouse Loacation",
                     },
                  

                    ],
            };


            $scope.Filter = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            
              $scope.Refresh = function () {
                  $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }





        }])
